import { render, staticRenderFns } from "./AbnormalTableCustomers.vue?vue&type=template&id=515e063d&scoped=true&"
import script from "./AbnormalTableCustomers.vue?vue&type=script&lang=js&"
export * from "./AbnormalTableCustomers.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalTableCustomers.vue?vue&type=style&index=0&id=515e063d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515e063d",
  null
  
)

export default component.exports